import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

const FIELDS = [
  ["ragione_sociale", "Ragione sociale"],
  ["brand_name", "Nome commerciale"],
  ["vat_code", "Partita IVA / Codice Fiscale"],
  ["legal_address", "Indirizzo sede legale"],
  ["support_email", "Email supporto"],
  ["admin_email", "Email amministrativa"],
  ["pec", "PEC (facoltativa)"],
  ["phone", "Telefono"],
  ["website", "Sito web"],
  ["logo_url", "Logo (URL)"],
];

export default function AdminCompany({ lang }) {
  const L = (it, en) => (lang === "en" ? en : it);
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/admin/company").then((r) => setC(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/company", c); setC(data); toast.success(L("Informazioni azienda salvate", "Company info saved")); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Error"); }
    finally { setBusy(false); }
  };

  if (!c) return <div className="py-10 text-center"><Loader2 className="w-6 h-6 animate-spin inline" /></div>;
  return (
    <div className="max-w-2xl" data-testid="admin-company">
      <h3 className="font-semibold mb-1">{L("Informazioni azienda", "Company information")}</h3>
      <p className="text-sm text-muted-foreground mb-5">{L("Questi dati sono usati nel footer, nei documenti legali, nelle email e nel PDF del modulo.", "Used in the footer, legal documents, emails and the module PDF.")}</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, label]) => (
          <div key={k} className={k === "logo_url" || k === "legal_address" ? "sm:col-span-2" : ""}>
            <Label className="text-xs">{label}</Label>
            <Input data-testid={`company-${k}`} className="mt-1" value={c[k] || ""} onChange={(e) => setC({ ...c, [k]: e.target.value })} />
          </div>
        ))}
      </div>
      <Button className="mt-5" onClick={save} disabled={busy} data-testid="company-save">
        {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />}{L("Salva", "Save")}
      </Button>
    </div>
  );
}
